import React, { useState } from "react";
import "./GlobalSettingsPage.scss";
import InvoiceSettings from "./InvoiceSettings/InvoiceSettings";
import ExpenseSettings from "./ExpensesSettings/ExpensesSettings";
import TaskSettings from "./TaskSettings/TaskSettings";
import LabelSettings from "./LabelSettings/LabelSettings";
import RightsSettings from "./RightsSettings/RightsSettings";
import VisibilitySettings from "./VisibilitySettings/VisibilitySettings";
import EmailConfigSettings from "./EmailConfigSettings/EmailConfigSettings";

const GlobalSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("rights");

  const renderContent = () => {
    switch (activeTab) {
      case "rights":
        return <RightsSettings />;
      case "invoice":
        return <InvoiceSettings />;
      case "expense":
        return <ExpenseSettings />;
      case "task":
        return <TaskSettings />;
      case "label":
        return <LabelSettings />;
      case "emailConfig":
        return <EmailConfigSettings />;
      // case 'visibility':
      //     return <VisibilitySettings />;
      default:
        return null;
    }
  };

  return (
    <div className="global-settings">
      <h1>Global Settings</h1>
      <div className="settings-tabs">
        <button
          className={activeTab === "rights" ? "active" : ""}
          onClick={() => setActiveTab("rights")}
        >
          Rights
        </button>
        <button
          className={activeTab === "invoice" ? "active" : ""}
          onClick={() => setActiveTab("invoice")}
        >
          Invoice
        </button>
        <button
          className={activeTab === "expense" ? "active" : ""}
          onClick={() => setActiveTab("expense")}
        >
          Expense
        </button>
        <button
          className={activeTab === "task" ? "active" : ""}
          onClick={() => setActiveTab("task")}
        >
          Task
        </button>
        <button
          className={activeTab === "label" ? "active" : ""}
          onClick={() => setActiveTab("label")}
        >
          Label
        </button>
         <button
          className={activeTab === "emailConfig" ? "active" : ""}
          onClick={() => setActiveTab("emailConfig")}
        >
          Invoice Email Configuration
        </button>

        {/* <button
                    className={activeTab === 'visibility' ? 'active' : ''}
                    onClick={() => setActiveTab('visibility')}
                >
                    Visibility
                </button> */}
      </div>

      <div className="settings-section">{renderContent()}</div>
    </div>
  );
};

export default GlobalSettingsPage;
